import React, { useState, useEffect } from 'react';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { Navigate, useLocation } from 'react-router-dom';
import B2BCheckoutView from './B2BCheckoutView';

const ModuleGuard = ({ children, requiredRole }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [hasRole, setHasRole] = useState(false);
  const location = useLocation();
  const auth = getAuth();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        setUser(currentUser);
        if (requiredRole) {
          try {
            const idTokenResult = await currentUser.getIdTokenResult();
            const role = (idTokenResult.claims?.role || '').toUpperCase();
            const isAdmin = role === 'ADMIN';

            if (isAdmin) {
              setHasRole(true);
            } else if (requiredRole.toUpperCase() === 'FINOPS') {
              // FinOps provides a self-service free/developer tier open to all authenticated users
              setHasRole(true);
            } else {
              setHasRole(role === requiredRole.toUpperCase());
            }
          } catch (err) {
            console.error("Error checking claims", err);
            setHasRole(false);
          }
        } else {
          setHasRole(true);
        }
      } else {
        setUser(null);
        setHasRole(false);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, [auth, requiredRole]);

  if (loading) {
    return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', color: 'var(--text-secondary)' }}>Cargando...</div>;
  }

  if (!user) {
    return <Navigate to={`/?redirect=${location.pathname}`} replace />;
  }

  if (requiredRole && !hasRole) {
    if (requiredRole.toUpperCase() === 'B2B') {
      return <B2BCheckoutView user={user} />;
    }
    return <div style={{ padding: '20px', textAlign: 'center' }}>No tienes acceso a este módulo.</div>;
  }

  return children;
};

export default ModuleGuard;
